/* ===========================================================================
   ROVE NEXT - open the cart drawer after Add to Cart. 25 August 2026.

   THE PROBLEM
   The theme already ships a working drawer: <theme-drawer id="cart-drawer">
   wrapping <cart-drawer-component>, with open() / close() / toggle().
   cart-drawer-component auto-opens when it hears StandardEvents.cartLinesUpdate
   with action "add" - but only if it carries an auto-open attribute, and it
   does not.

   More importantly, sections/rn-buybox.liquid renders its own <form> with a
   plain <button class="bb-atc" type="submit"> that is NOT inside
   product-form-component, so none of the theme's cart plumbing runs for it.
   The item lands in the cart and nothing on screen changes.

   THE APPROACH
   Wrap window.fetch rather than intercept the submit. The buy box already
   posts to /cart/add.js itself; intercepting the form would either fight that
   handler or add the item twice. Watching fetch is non-invasive, and it also
   covers Frequently Bought Together, which posts the same way.

   WHY THE ORDER MATTERS - this is what was broken.
   The first version replaced the innerHTML of the whole section wrapper, which
   destroys and recreates <theme-drawer> itself, and then called open() on the
   replacement. The item was added and the section re-rendered, but the drawer
   stayed shut: measured open attribute false, dialog width 0, every time.

   So: open the LIVE element first, while it is still the element the theme
   wired up, then replace only the <cart-drawer-component> inside it. The
   drawer never stops existing, so it never loses its open state.

   Scripts arriving in the fragment are appended by hand, because scripts
   inserted through innerHTML do not execute, and those are what define the
   quantity stepper and the remove button.

   The header is re-rendered in the same request so the cart count updates.
   That one can still be swapped wholesale - nothing there holds state.
   =========================================================================== */
(function () {
  var DRAWER_SECTION = 'cart-drawer-section';
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var busy = false;

  function headerSectionId() {
    var h = document.querySelector('[id^="shopify-section-sections--"][id$="__rn_header"]');
    return h ? h.id.replace('shopify-section-', '') : null;
  }

  function runFragmentScripts(doc) {
    var nodes = doc.querySelectorAll('script[src]');
    for (var i = 0; i < nodes.length; i++) {
      var src = nodes[i].getAttribute('src');
      if (!src || document.querySelector('script[src="' + src + '"]')) continue;
      var s = document.createElement('script');
      s.src = src;
      s.defer = true;
      document.head.appendChild(s);
    }
  }

  /* A WRITE THAT LANDS MID-REFRESH IS NOT DROPPED. 26 September 2026.
     This used to `return` while a refresh was in flight. Bundle and save
     writes twice back to back -- the sofa, then assets/rn-pdp-addon.js adds
     the ticked add-ons once it hears the sofa is in -- and the second write's
     refresh was thrown away. The drawer kept the sofa-only render, whose line
     numbers were now all wrong (Shopify puts new lines first), so changing a
     quantity or removing a line in it changed a DIFFERENT item. Now a write
     during a refresh is remembered, and one more refresh runs after this one,
     so the drawer always ends on the cart as it really is. */
  var again = false;
  function refreshAndOpen() {
    if (busy) { again = true; return; }
    busy = true;
    again = false;
    var wanted = [DRAWER_SECTION];
    var hdr = headerSectionId();
    if (hdr) wanted.push(hdr);

    fetch('/?sections=' + wanted.join(','), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        var drawer = document.getElementById('cart-drawer');

        // open the live element BEFORE touching anything inside it
        if (drawer && typeof drawer.open === 'function') drawer.open();

        var html = data[DRAWER_SECTION];
        if (drawer && html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('cart-drawer-component');
          var current = drawer.querySelector('cart-drawer-component');
          if (fresh && current) current.replaceWith(fresh);
          runFragmentScripts(doc);
        }

        if (hdr && data[hdr]) {
          var host = document.getElementById('shopify-section-' + hdr);
          var hfresh = new DOMParser().parseFromString(data[hdr], 'text/html')
            .getElementById('shopify-section-' + hdr);
          if (host && hfresh) host.innerHTML = hfresh.innerHTML;
        }
      })
      .catch(function (e) { console.warn('[rn-pdp-cart]', e); })
      .then(function () {
        busy = false;
        if (again) refreshAndOpen();
      });
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch !== 'function' || nativeFetch.__rnCartWrapped) return;

  var wrapped = function (input, init) {
    var url = typeof input === 'string' ? input
            : (input && input.url) ? input.url : '';
    var promise = nativeFetch.apply(this, arguments);
    if (CART_WRITE.test(url)) {
      promise.then(function (res) {
        if (res && res.ok) setTimeout(refreshAndOpen, 80);
      }).catch(function () { /* the caller reports its own failure */ });
    }
    return promise;
  };
  wrapped.__rnCartWrapped = true;
  window.fetch = wrapped;
})();
